<section class="section c-login sped-wallpaper">
  <div class="login">
    <img src="./assets/logo-sped.jpg" alt="sped automation logo">
    <form [formGroup]="formPassword" class="c-form" (ngSubmit)="savePassword()" *ngIf="!authCodeInvalido; else elseTemplate">
      <div class="c-form-row">
        <div class="c-form-column">
          <div class="input-container">
            <p class="-bold">
              Nova Senha 
              <app-tooltip-info [texto]="textoTooltipSenhas"></app-tooltip-info>
            </p>
            
            <input matInput placeholder="Entre com a nova senha" showControlErrors class="o-input"
              formControlName="senha" type="password">
          </div>
        </div>
      </div>
      <div class="c-form-row">
        <div class="c-form-column">
          <div class="input-container">
            <p class="-bold">Confirmar Senha</p>
            <input matInput placeholder="Preencha novamente" showControlErrors class="o-input"
              formControlName="confirmarSenha" type="password">
          </div>
        </div>
      </div>
      <div class="c-form-row -flexCenter">
        <div class="c-form-column -flex -flexEnd">
          <button type="submit" class="o-button -blue">Salvar</button>
        </div>
      </div>
    </form>
    <ng-template #elseTemplate>
      <div class="centraliza">
        <h2>Erro! Link inválido para criar senha.</h2>
      </div>
    </ng-template>
  </div>
</section>